<template>
  <div class="text-center">
    <i
      class="fas fa-spinner fa-spin fa-2x text-secondary"
    />
  </div>
</template>

<script>
export default {
  name: 'LoadingIndicator',
};
</script>
